import React from 'react'
import { useLazyLoad } from '_hooks'

const formatData = (obj) =>
  Object.entries(obj).map(([key, val]) => ({ name: key, value: parseFloat(val) / 100 }))

const BarChart = ({ data, title }) => {
  const [
    { BarChart: BarChartRecharts, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer },
    loadingRecharts,
  ] = useLazyLoad(import('recharts'))

  return (
    <If condition={!loadingRecharts}>
      <ResponsiveContainer debounce={5} width="99%" height={350}>
        <BarChartRecharts data={formatData(data)} layout="vertical">
          <YAxis dataKey="name" type="category" width={150} />
          <XAxis
            label={{
              value: 'Probability',
              position: 'bottom',
              offset: -7,
            }}
            type="number"
          />
          <Tooltip />
          <Bar dataKey="value" fill="#689E77" />
        </BarChartRecharts>
      </ResponsiveContainer>
    </If>
  )
}

export default BarChart
